// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import dateScreen from '@/views/data_screen/data_screen';


// 启用路由
Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login', /* 登录界面 */
            name: 'login',
            component: login/* ,hidden: true, // 自定义属性，在组件中可以通过 this.$route.hidden 获取值 */
        },
        {
            path: '/dateScreen',
            component: dateScreen,
            name: 'dateScreen',
            meta: {
                keepAlive: false,
                auth: true
            }
        },
    ]
});
router.beforeEach((to, from, next) => {// 注册一个全局前置守卫
    let token = sessionStorage.getItem('token');
    // eslint-disable-next-line eqeqeqgetAttribute,eqeqeq

    // eslint-disable-next-line eqeqeq
    if (to.path.indexOf('/login') != -1) {
        next();
    } else {
        // if (!token) {
        //   alert('登录超时');
        //   // this.$message({
        //   //   message: '登录超时!',
        //   //   type: 'warning'
        //   // });
        //   next({// 校验失败，跳转至登录界面
        //     path: '/login',
        //     query: {
        //       redirect: to.fullPath
        //     }// 将跳转的路由path作为参数，用于在登录成功后获取并跳转到该路径
        //   });
        // }
        next();
    }
    next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js